import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import { useSelector } from "react-redux";
import {
  GetCobraByClientName,
  UpdateCobra,
} from "../../../../api/User/ACG/COBRAParticipationApi";

const schema = Yup.object().shape({
  cobra_Participation: Yup.number()
    .typeError("Please enter a valid number")
    .required("required"),
});

const COBRAParticipation = () => {
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Carrier", field: "carrier" },
    {
      title: "Cobra Participation",
      field: "cobrA_Pct",
      render: (rowData) => {
        let value = +rowData.cobrA_Pct * 100;
        return value.toFixed(2) + "%";
      },
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getData();
  }, [client]);

  const getData = () => {
    setIsLoading(true);
    GetCobraByClientName(client?.clientID)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    const { cobra_Participation } = values;
    const payload = {
      id: selectedRowData.id,
      client_ID: client?.clientID,
      carrier: selectedRowData?.carrier,
      cobrA_Pct: +cobra_Participation,
    };
    UpdateCobra(payload).then((res) => {
      if (res.status === 200 || res.status === 204) {
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
      }
    });
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Update Cobra Participation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              cobra_Participation: selectedRowData?.cobrA_Pct ?? 0,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <CustomInputField
                    label="Cobra Participation"
                    name="cobra_Participation"
                    maxLength={10}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    isRequired
                  />
                </Row>
                <div className="text-end my-4">
                  <CustomButton
                    Ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    Save
                  </CustomButton>
                  <CustomButton
                    style={Fontstyling.cancelbutton}
                    onClick={() => setShowModal(false)}
                    type="button"
                  >
                    Cancel
                  </CustomButton>
                </div>
                <span className="text-success" style={{ fontSize: "12px" }}>
                  * No special characters are allowed
                </span>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <CustomMaterialTable
        isExport={false}
        isDelete={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={() => {}}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default COBRAParticipation;
